import { PostVoteT } from '../../../model/types';

interface IAddNewVoteArgs {
  $newPretendents: PostVoteT;
  $firstStageVotes: PostVoteT;
}
export const addNewVote = ({
  $firstStageVotes,
  $newPretendents
}: IAddNewVoteArgs): PostVoteT => ({
  ...$firstStageVotes,
  ...$newPretendents
});
